module.exports = __webpack_public_path__ + "img/Head-Left-Side@2x.4ab6df9b.png";